import {StockLevelOverwrite} from '@hconnect/common/types'
import {ScaleLinear, ScaleTime} from 'd3'
import {Moment} from 'moment-timezone'
import {useMemo} from 'react'

import {DatetimeValue} from '../../../../shared/interfaces/common'
import {StockDevelopmentData} from '../../../../shared/selectors/stockDevelopment'

export type StockDevelopmentChartConfig = {
  yScale: ScaleLinear<number, number, never>
  xScale: ScaleTime<number, number, never>
  verticalSteps: number[]
  minStockValue: number
  maxMinTargetLevelDatetimeValues: number
  minTargetLevelBaseValue: number
  formatDatetime: (datetime: Moment) => string
  formatTooltipContent: (datetimeValue: DatetimeValue) => JSX.Element
  timezoneId: string
}

export function useStockDevelopmentChartMinMaxRanges({
  stockData,
  minTargetLevels,
  storageCapacity
}: {
  stockData: StockDevelopmentData & {
    stockOverwrites?: StockLevelOverwrite[]
  }
  minTargetLevels?: {weekend: number; week: number}
  storageCapacity?: number
}) {
  return useMemo(() => {
    const {stockLevelHourly} = stockData

    const stockDevelopmentValues = Object.values(stockLevelHourly)
    const maxStockValue: number = Math.max(...stockDevelopmentValues)
    const minStockValue: number = Math.min(...stockDevelopmentValues)

    const maxValue = Math.max(
      maxStockValue,
      ...(minTargetLevels ? [minTargetLevels.week, minTargetLevels.weekend] : []),
      ...(storageCapacity ? [storageCapacity] : [])
    )
    const maxDomainValue = maxValue
    const minDomainValue = Math.min(0, minStockValue)

    return {minDomainValue, maxDomainValue, minStockValue, maxStockValue}
  }, [stockData, minTargetLevels, storageCapacity])
}
